import { Box, FormControl, Select } from '@chakra-ui/react';
import { NewConcept } from '@texas/components/customer/newConcept/NewConcept';
import { NewCustomer } from '@texas/components/customer/newCustomer/NewCustomer';
import { WarningComponent } from '@texas/components/shared/WarningComponent';
import { TexasFormLabel } from '@texas/components/shared/form/TexasFormLabel';
import { TexasSelect } from '@texas/components/shared/form/TexasSelect';
import { createArticleStyles as styles } from '@texas/resources/theme/styles/entityWorkspace';
import { ReactSelectOption } from '@texas/types';
import { useTranslation } from 'react-i18next';
import { ManagementCard } from '../manage/ManagementCard';
import { useCreateArticle } from './useCreateArticle';

export function CreateArticleInformation() {
  const { t } = useTranslation();
  const createArticle = useCreateArticle();
  return (
    <ManagementCard
      className="create-article-card"
      title={t('article.create.information')}
    >
      <Box sx={styles.stack}>
        <Box sx={styles.fields}>
          <Box id={createArticle.fieldWarnings.customer.targetId}>
            <FormControl isRequired={true}>
              <WarningComponent {...createArticle.fieldWarnings.customer}>
                <TexasFormLabel>{t('article.copy.customer')}</TexasFormLabel>
              </WarningComponent>
              <TexasSelect<ReactSelectOption>
                classNamePrefix="create-article-select"
                options={createArticle.search.options}
                inputValue={createArticle.search.input}
                onInputChange={createArticle.search.setInput}
                isLoading={createArticle.search.loading}
                value={createArticle.customer}
                onChange={createArticle.selectCustomer}
                placeholder={t('article.copy.customerSearchMinimum')}
              />
              <NewCustomer
                buttonLabel={t('article.create.newCustomer')}
                submitLabel={t('article.create.createAndSelect')}
                buttonProps={{ variant: 'formInlineCreate' }}
                onCreated={(c) =>
                  createArticle.selectCustomer({
                    value: c.id,
                    label: c.name,
                  })
                }
              />
            </FormControl>
          </Box>
          <FormControl>
            <TexasFormLabel>{t('general.concept')}</TexasFormLabel>
            <Select
              value={createArticle.conceptId ?? ''}
              isDisabled={!createArticle.customerId}
              onChange={(e) =>
                createArticle.setValue(
                  'conceptId',
                  Number(e.target.value) || null,
                )
              }
            >
              <option value="">{t('general.none')}</option>
              {(createArticle.resources.concepts.data ?? []).map((c) => (
                <option key={c.id} value={c.id}>
                  {c.name}
                </option>
              ))}
            </Select>
            <NewConcept
              customerId={createArticle.customerId}
              buttonLabel={t('article.create.newConcept')}
              submitLabel={t('article.create.createAndSelect')}
              buttonProps={{
                variant: 'formInlineCreate',
                isDisabled: !createArticle.customerId,
              }}
              onCreated={(c) => {
                if (c.customerId !== createArticle.customerId) {
                  void createArticle.refetchInitialCustomer(c.customerId);
                  createArticle.setValue('contactId', null);
                }
                createArticle.setConcepts((previous) => [
                  ...(previous ?? []),
                  { id: c.id, name: c.name },
                ]);
                createArticle.setValue('conceptId', c.id);
              }}
            />
          </FormControl>
        </Box>
      </Box>
    </ManagementCard>
  );
}
